<template>
  <div>
    <b-table striped hover
      :items="theData"
      :fields="[{key: 'change', label: $gettext('Change')}, {key: 'by', label: $gettext('By')}, {key: 'at', label: $gettext('At')}]"
      :per-page="perPage"
      :total-rows="totalRows"
    >
      <template v-slot:cell(change)="row">
        <div v-if="!row.item.hiddenData" v-html="row.value"></div>
        <div v-else>
          <b-button size="sm" variant="primary" @click.prevent="row.item.showOriginal = !row.item.showOriginal" class="mb-3">
            <span v-show="!row.item.showOriginal" v-translate>Show Data</span>
            <span v-show="row.item.showOriginal" v-translate>Hide Data</span>
          </b-button>
          <div v-if="row.item.showOriginal" v-html="row.value"></div>
        </div>
        </template>
      <template v-slot:cell(by)="row">
        {{row.item.applied_by?.name ?? $gettext('System')}}
      </template>
      <template v-slot:cell(at)="row">
        {{moment.utc(row.item.created_at).tz($tz).format('L LT')}}
      </template>
    </b-table>
    <b-pagination :total-rows="totalRows" :per-page="perPage" @input="emitPageChanged" v-model="currentPage" v-if="totalRows > perPage" class="my-0" />
  </div>
</template>

<script>
  export default {
    name: 'LogList',
    props: {
      log: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        theData: [],
        currentPage: 0,
        perPage: 25,
        totalRows: 0
      }
    },
    watch: {
      log(newValue, oldValue) {
        this.theData = newValue.data
        this.totalRows = newValue.pagination.total
        this.currentPage = newValue.pagination.page
        this.perPage = newValue.pagination.limit
      }
    },
    mounted () {
      if (this.log.data) {
        this.theData = this.log.data
        this.totalRows = this.log.pagination.total
        this.currentPage = this.log.pagination.page
        this.perPage = this.log.pagination.limit
      }
    },
    methods: {
      emitPageChanged($e) {
        this.$emit('page-changed', $e)
      }
    }
  }
</script>
